import { render, staticRenderFns } from "./ui-switch.vue?vue&type=template&id=cd989e5a&scoped=true&"
import script from "./ui-switch.vue?vue&type=script&lang=js&"
export * from "./ui-switch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd989e5a",
  null
  
)

export default component.exports